/**
 * @see https://stackoverflow.com/a/30527650/5219328
 */

const getScrollStep = (targetPosition, currentPosition, scrollRate) =>
  Math.ceil((targetPosition - currentPosition) / scrollRate);

const getPositionsDiff = (targetPosition, currentPosition) =>
  Math.abs(currentPosition - targetPosition);

const isTargetPositionReached = (targetPosition, currentPosition) =>
  currentPosition === targetPosition ||
  getPositionsDiff(targetPosition, currentPosition) < 1;

const smoothScroll = (
  container,
  targetScrollPosition,
  scrollRate = 5,
  onAnimationEnd,
) => {
  if (!container) {
    return;
  }

  const currentScrollPosition = container.scrollTop || 0;

  if (isTargetPositionReached(targetScrollPosition, currentScrollPosition)) {
    if (typeof onAnimationEnd === "function") {
      onAnimationEnd();
    }
    return;
  }

  if (
    getPositionsDiff(targetScrollPosition, currentScrollPosition) < scrollRate
  ) {
    container.scrollTop = targetScrollPosition;
  } else {
    container.scrollTop =
      currentScrollPosition +
      getScrollStep(targetScrollPosition, currentScrollPosition, scrollRate);
  }

  window.requestAnimationFrame(() =>
    smoothScroll(container, targetScrollPosition, scrollRate, onAnimationEnd),
  );
};

export { smoothScroll };
